import type { ExcelColumn } from './excel';

export const INBOUNDS_XLSX_COLUMNS: ReadonlyArray<ExcelColumn> = [
  { title: 'Поступление',   key: 'inboundId' },
  { title: 'Дата',          key: 'date' },
  { title: 'Поставщик',     key: 'supplier' },
  { title: 'Товар',         key: 'itemName' },
  { title: 'SKU',           key: 'sku' },
  { title: 'Кол-во',        key: 'qty' },
  { title: 'Цена закупки',  key: 'unitCost' },
  { title: 'Сумма',         key: 'totalCost' },
] as const;

export type InboundRow = {
  inboundId: string; date: string; supplier: string; itemName: string; sku: string;
  qty: number | string; unitCost: number | string; totalCost: number | string;
};

export function mapInboundToRows(ib: any): InboundRow[] {
  const inboundId = ib.id ?? ib.code ?? '—';
  const date = ib.createdAt ? new Date(ib.createdAt).toLocaleString('ru-RU') : (ib.date ?? '—');
  const supplier = ib.supplier ?? ib.vendor ?? '—';
  const lines = Array.isArray(ib.lines) ? ib.lines : [];

  if (!lines.length) {
    return [{ inboundId, date, supplier, itemName: '(без позиций)', sku: '—', qty: ib.qty ?? 0, unitCost: '', totalCost: ib.totalCost ?? '' }];
  }

  return lines.map((l: any) => {
    const qty = Number(l.qty ?? 0);
    const unit = l.unitCost != null ? Number(l.unitCost) : '';
    const total = l.totalCost != null ? Number(l.totalCost) : (l.unitCost != null ? Number(l.unitCost) * qty : '');
    return { inboundId, date, supplier, itemName: l.name ?? '—', sku: l.sku ?? '—', qty, unitCost: unit, totalCost: total };
  });
}

export const getInboundTime = (ib: any) => {
  const v = ib.createdAt ?? ib.date ?? 0;
  const t = new Date(v).getTime();
  return Number.isFinite(t) ? t : null;
};
